import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { fetchWeddingData } from 'apollo/projects.query';

import { Loading } from 'components/Loading';
import HorizontalMenu from 'components/Menus/HorizontalMenu';
import ProjectsSettingsDetails from './ProjectsSettings.Details';
import ProjectsSettingsNotifications from './ProjectsSettings.Notifications';
import './styles.scss';

const ProjectSettings = ({
  type = 1,
  weddingId,
  updateWeddingChanges,
  pushNotification,
  projectCreatedCallback,
  projectCreatedErrorCallback,
  formData: _formData,
}) => {
  const [projectSettingsType, setProjectSettingsType] = useState(0);
  const [formData, setFormData] = useState(_formData ?? null);

  useEffect(() => {
    const getWeddingData = async () => {
      const data = await fetchWeddingData({ id: weddingId });
      if (data) {
        setFormData(data.wedding);
      }
    };
    if (weddingId !== null && projectSettingsType === 0) {
      getWeddingData();
    }
  }, [weddingId, projectSettingsType]);

  const items = [
    {
      id: 'details',
      name: (<><span className="visually-hidden--mobile">Project</span> Details</>),
      onClick: () => setProjectSettingsType(0),
      active: projectSettingsType === 0,
    },
    {
      id: 'notifications',
      name: 'Notifications',
      onClick: () => setProjectSettingsType(1),
      active: projectSettingsType === 1,
    },
  ];

  if (weddingId && !formData) {
    return (
      <Loading />
    );
  }

  return (
    <>
      {weddingId && (
        <HorizontalMenu
          items={items}
        />
      )}
      {projectSettingsType === 0 && (
        <ProjectsSettingsDetails
          type={type}
          weddingId={weddingId}
          formData={formData}
          projectCreatedCallback={projectCreatedCallback}
          projectCreatedErrorCallback={projectCreatedErrorCallback}
          updateWeddingChanges={updateWeddingChanges}
          pushNotification={pushNotification}
        />
      )}
      {projectSettingsType === 1 && (
        <ProjectsSettingsNotifications
          id={weddingId}
          pushNotification={pushNotification}
        />
      )}
    </>
  );
};

ProjectSettings.propTypes = {
  type: PropTypes.number,
};

ProjectSettings.defaultProps = {};

export default ProjectSettings;
